export const formates = {
	date: 'dd.MM.yyyy',
}
